export default __webpack_public_path__ + "static/media/menu_arrows.36fa810a.svg";